import axios from "axios";


//const APIBaseUrl = "http://DESKTOP-LD7A4JN:8002/shambasync/v1";
// const APIBaseUrl = "http://192.168.1.20:8002/shambasync/v1";
// const APIBaseUrl = "http://192.168.17.58:8002/shambasync/v1";
const APIBaseUrl = "https://marketplace.shambasync.com/shambasync/v1";

export const productParticular = async (path, params = {}) => {
    try {
        const response = await axios.get(`${APIBaseUrl}${path}`, {
            params,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error("GET API Error:", error);
        return error?.response?.data || { message: "Unknown error", statusCode: 500 };
    }
}


export const postWithoutTokenAPI = async (path, payload) => {
    try {
      const isFormData = payload instanceof FormData;
  
      const headers = {
        Accept: 'application/json',
      };
  
      // Only set 'Content-Type' if payload is not FormData
      if (!isFormData) {
        headers['Content-Type'] = 'application/json';
      }
  
      const response = await axios.post(`${APIBaseUrl}${path}`, payload, { headers });
  
      return response.data;
    } catch (error) {
      // Handle error appropriately
      console.error('API request failed:', error);
      return { error: error };
    }
};

export const postWithTokenAPI = async (token, path, payload) => {
    try {
        if (!token) {
            throw new Error('No authentication token provided');
        }

        const isFormData = payload instanceof FormData;
        const headers = {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
        };

        if (!isFormData) {
            headers['Content-Type'] = 'application/json';
        }


        const response = await axios.post(`${APIBaseUrl}${path}`, payload, { headers });
        return response.data;
    } catch (error) {
        console.error('API request failed:', error);
        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            return {
                statusCode: error.response.status,
                message: error.response.data?.message || 'Request failed',
                error: error.response.data
            };
        } else if (error.request) {
            // The request was made but no response was received
            return {
                statusCode: 500,
                message: 'No response received from server',
                error: error.message
            };
        } else {
            // Something happened in setting up the request that triggered an Error
            return {
                statusCode: 500,
                message: error.message || 'Request setup failed',
                error: error
            };
        }
    }
};


export const mypostWithTokenAPI = async (url, body) => {
    const token = localStorage.getItem('token');
    const response = await fetch(APIBaseUrl + url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(body)
    });
    return response.json();
};
export const getWithTokenAPI = async (token,path) => {
    const response = await axios
        .get(`${APIBaseUrl}`+path, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": "Bearer " + token
            },
        })
        .then((response) => {
            return response.data;
        })
        .catch((error) => ({ error: error }));
    return response;
};

export const getWithoutTokenAPI = async (path) => {
    const response = await axios
        .get(`${APIBaseUrl}`+path, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response.data;
        })
        .catch((error) => ({ error: error }));
    return response;
};
  
export const putAPI = async (token,path,payload) => {
    const response = await axios
        .put(`${APIBaseUrl}`+path,payload, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": "Bearer " + token
            },
        })
        .then((response) => {
            return response.data;
        })
        .catch((error) => ({ error: error }));
    return response;
};

export const putwithoutAPI = async (path, data) => {
    try {
        const response = await axios.put(`${APIBaseUrl}${path}`, data, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error("PUT API Error:", error);
        return error?.response?.data || { message: "Unknown error", statusCode: 500 };
    }
};
export const deleteAPI = async (token,path,payload) => {
    const response = await axios
        .delete(`${APIBaseUrl}`+path, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": "Bearer " + token
            },
            data: payload
        })
        .then((response) => {
            return response.data;
        })
        .catch((error) => ({ error: error }));
    return response;
};
// export const deleteAPI = async (token, path, payload) => {
//     const response = await axios
//       .delete(`${APIBaseUrl}${path}`, {
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "application/json",
//           "Authorization": `Bearer ${token}`,
//         },
//         data: payload // the actual body for the DELETE request
//       })
//       .then((response) => response.data)
//       .catch((error) => ({ error }));
  
//     return response;
//   };

// export const deleteAPI = (token, url, data = {}) => {
//     return axios.delete(url, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//         'Content-Type': 'application/json',
//       },
//       data,
//     });
//   };
  


export const UploadDocument = async (path, data) => {
    const response = await axios
        .put(`${APIBaseUrl}${path}`, data, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
            return response.data;
        })
        .catch((error) => ({ error: error }));
    return response;
};  